import axios from "axios";

export const axiosInstance_agent = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL_AGENT,
});

console.log("API Base URL:", process.env.REACT_APP_API_BASE_URL_AGENT);

axiosInstance_agent.interceptors.request.use(
  function (config) {
    // const token = localStorage.getItem("token");
    const token = sessionStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    // console.log("Request Headers:", config.headers);
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

axiosInstance_agent.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);
